import {useState} from "react";
import {isNullOrUndefined} from "../../../services/Validator";
import SystemIcon from "../../icons/SystemIcon";
import CoursesLevelATaskText from "../../texts/courses/CoursesLevelATaskText";
import SystemHorizontalStarDivider from "../../dividers/courses/flash/SystemHorizontalStarDivider";
import {kInternalRoutes} from "../../../constants/internalRoutes";
import {useNavigate} from "react-router-dom";

export default function CoursesLevelAItem({ index,
                                            total,
                                            levelA,
                                            selectedLevelAs}) {
    // Used in LevelDesktopSchoolLevelsList to display one single
    // level card

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)
    let navigate = useNavigate()

    // BUILD
    if (isNullOrUndefined(levelA) || isNullOrUndefined(selectedLevelAs))
        return null
    return (
        <div className="w-full flex flex-col space-y-[6px]">
            <div className={`cursor-pointer w-full flex justify-between items-center px-[16px] py-[8px]`}
                 onClick={() => goToLevelAScreen(levelA?.slug)}
                 onMouseEnter={() => setIsHovered(true)}
                 onMouseLeave={() => setIsHovered(false)}>
                {/** CORE CONTENT */}
                <CoursesLevelATaskText taskText={levelA?.task}
                                       isHovered={isHovered}/>
                <SystemIcon icon={"chevron_right"}
                            isHovered={isHovered} />
            </div>
            {/** BOTTOM DIVIDER IF NECESSARY */}
            {index === (total - 1) ? null : <SystemHorizontalStarDivider />}
        </div>
    );

    // METHODS
    // ---- NAV : Navigate to LevelAScreen with current LevelA
    function goToLevelAScreen(slug) {
        navigate(`/savoir-faire/${slug}`, {
            state: { from: kInternalRoutes.courses }
        })
    }
}